import axiosAuth from '../../axios/auth';
import axiosOrders from '../../axios/quickOrders';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
import { routes } from '../../router/routes';
import { store } from '../store';
// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {

    cardsCached : JSON.parse( localStorage.getItem( 'cardsCached' ) ) || true,
    wallet      : [],
    currentCard : JSON.parse( localStorage.getItem( 'currentCard' ) ) || null,
    cof         : JSON.parse( localStorage.getItem( 'cof'         ) ) || null,
    cardExpired : 0,
    currentViewCard: JSON.parse(localStorage.getItem('currentViewCard')) || null
};

const mutations = {

    setCards( state, data ){

        // console.log( 'data coming through..', data );
        if( data.body.length > 0 ){

            let dbPromise = idb.open( 'quickOrdersDB', data.idbVersion );
            dbPromise.then( db => {

                var txCardWallet;
                try {
                    txCardWallet = db.transaction( 'cardWallet', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }
                //console.log("tx cardWallet",txCardWallet);
                txCardWallet.objectStore( 'cardWallet' ).clear();
                data.body.forEach( value => {

                    //console.log( 'cards data: ', value );
                    txCardWallet.objectStore( 'cardWallet' ).put( value );
                    state.wallet.push( value );
                });
            });
        }
        const timestamp = parseInt( new Date().getTime() );
        state.cardsCached = timestamp;
        localStorage.setItem( 'cardsCached', timestamp );
    },
    saveCofLocally( state, cof ){

        state.cof = cof;
        localStorage.setItem( 'cof', JSON.stringify( cof ) );
    },
    clearCofLocally( state ){

        state.cof = null;
        localStorage.removeItem( 'cof' );

    },
    toggleCache( state ){ // not up to date with the new timestamp-cache strategy, DO NOT USE UNLESS UPDATED

        // console.log( 'old cache: ', state.cardsCached );
        state.cardsCached = !state.cardsCached;
        // console.log( 'new cache: ', state.cardsCached );
        localStorage.setItem( 'cardsCached', state.cardsCached );
    },
    viewCard( state, cardId ){

        localStorage.setItem( 'currentCard', cardId );
        state.currentCard = cardId;
    },
    currentViewCard(state, cardId) {

        localStorage.setItem('currentViewCard', cardId);
        state.currentViewCard = cardId;
    },
    selectCard(state, cardId){
        localStorage.setItem('currentCard', cardId);
        state.currentCard = cardId;
    },
    clearCurrentCard(state){
        //console.log('im clear');
        state.currentCard = null;
        localStorage.removeItem('currentCard');
    },
    clearState( state ){

        state.wallet = [];

        state.cardsCached = null;
        localStorage.removeItem( 'cardsCached' );

        state.currentCard = null;
        localStorage.removeItem( 'currentCard' );
    },
    cleanCardsWithout( state ) {
        state.wallet = [];

        state.cardsCached = null;
        localStorage.removeItem('cardsCached');
    }
};

const actions = {

    getCards( { commit, getters, rootGetters } ){
        if( getters.cardsCached == null || parseInt( getters.cardsCached ) + parseInt( 5 * 60 * 1000 ) < parseInt( new Date().getTime() ) ){ // only load if not cached within recently
            // for the bonus car
            axiosAuth({

                method: 'post',
                url: '/getCardWallet',
                data: '',
                headers: {

                    'Content-Type' : 'application/x-www-form-urlencoded',
                    'AuthType'     : 'JWT',
                    'ApiKey'       : process.env.VUE_APP_API_KEY,
                    'Token'        : localStorage.getItem( 'token' ) || null
                }
            }).then( res => {

                 //console.log( 'result getCards: ', res.data );
                if( res.data.responseCode == 100 ){

                    //console.log("card length", getters.wallet.length);
                    // run a diff
                    if( getters.wallet.length > 0 ){ // we have some currently loaded
                        res.data.body.forEach( ( card, key ) => {

                            for( let i = 0; i < getters.wallet.length; i++ ){

                                if( card.PrepaidAccount.prepaidAccountId == getters.wallet[ i ].PrepaidAccount.prepaidAccountId ){

                                    res.data.body[ key ].alreadyExists = true;
                                    break;
                                }
                            }
                        });

                        const newCards = res.data.body.filter( card => !card.alreadyExists );
                        const payload = {

                            body       : newCards, // only push the new ones not previously seen
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setCards', payload );
                    } else {

                        const payload = {

                            body       : res.data.body,
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setCards', payload );
                    }
                } else {
                    //console.log( 'server error' );
                }
            }).catch( err => {

                //console.error( 'error! ', err );
            });
        }
    },
    getPaymentOptions( { commit, getters, rootGetters } ){

        //console.log( 'getting payment options..' );
        axiosOrders({

            method: 'post',
            url: '/getDefaultCard',
            data: qs.stringify({

                    merchantId         : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                    merchantLocationId : rootGetters[ 'merchant/currentLocation' ].locationId
                }),
            headers: {

                'Content-Type' : 'application/x-www-form-urlencoded',
                'AuthType'     : 'JWT',
                'ApiKey'       : process.env.VUE_APP_API_KEY,
                'Token'        : localStorage.getItem( 'token' ) || null
            }
        }).then( res => {

            //console.log( 'result RES: ', res );
            if( res.data.responseCode == 100 ){

                const cards = res.data.cards;
                //console.log( 'result CARDS: ', cards );
                let formattedCards = [];
                cards.forEach( card => {

                    formattedCards.push( {

                        'cardId'    : card.cardId,
                        'last4'     : card.last4,
                        'name'      : card.name,
                        'network'   : card.network
                    });
                });

                commit( 'saveCofLocally', formattedCards );
            }

        }).catch( err => {

            //console.error( 'error! ', err );
            //console.log( 'the error: ', err );
        });
    },
    toggleCache( { commit } ){

        commit( 'toggleCache' );
    },
    viewCard( { commit, rootGetters }, card ){

        commit( 'viewCard', card.PrepaidAccount.prepaidAccountId );
        router.push({

            name: 'view-card',
            params: { slug : rootGetters[ 'merchant/merchantSlug' ] }
        });
    },
    currentViewCard({ commit, rootGetters }, card) {

        commit('currentViewCard', card.PrepaidAccount.prepaidAccountId);
        router.push({

            name: 'view-card',
            params: { slug: rootGetters['merchant/merchantSlug'] }
        });
    },
    selectCard({ commit, dispatch, getters, state }, card){
        //console.log("select card");
        //Clean and get Cards again

        //Check if the card is available
        if (getters.filteredCardsByMerchant.length > 0){

            for (let c of getters.filteredCardsByMerchant ) {
                //console.log("actual card",card.PrepaidAccount.prepaidAccountId);
                //console.log("total cards", c.PrepaidAccount.prepaidAccountId);
                if (card.PrepaidAccount.prepaidAccountId == c.PrepaidAccount.prepaidAccountId ){
                    //console.log('is valid');
                    state.cardExpired = 0;
                    commit('selectCard', card.PrepaidAccount.prepaidAccountId);
                    router.push({
                        name: 'order-tab'
                    });
                    break;
                } else {
                    //This card does not exists or expired
                    state.cardExpired = 1;
                }
            }

        } else {
            state.cardExpired = 1;
        }

    },
    cleanCards({ commit, dispatch }) {
        //console.log('im in cleanCards');
        commit('clearState');
        dispatch('getCards');
    },
    cleanCardsWithoutCurrent({ dispatch }) {
        //console.log('cleanCards');
        dispatch('cleanCardsWithout');
        dispatch('getCards');
    },
    cleanCardsForDelivery({ dispatch }) {
        console.log('cleanCardsForDelivery');
        dispatch('cleanCardsWithout');
    },
    clearCurrentCard({ commit }){
        //console.log('im clearcurrent');
        commit( 'clearCurrentCard' );
        router.push({
            name: 'order-tab'
        });
    },
    clearState( { commit } ){
        commit( 'clearState' );
    },
    cleanCardsWithout( { commit } ) {
        //console.log('clean2');
        commit('cleanCardsWithout');
    }
};

const getters = {

    cardsCached : state => state.cardsCached,
    wallet      : state => state.wallet,
    currentViewCard(state) {

        return state.wallet.filter(card => {
            if (card.PrepaidAccount.prepaidAccountId == state.currentViewCard) return card;
        })[0];
    },
    currentCard( state ){

        return state.wallet.filter( card => {
            if (card.PrepaidAccount.prepaidAccountId == state.currentCard && card.PrepaidAccount.balance > 0 && card.PrepaidAccount.prepaidAccountTypeId == 3 ) return card;
        })[ 0 ];
    },
    cof           : state => state.cof,
    hasCardOnFile : state => state.cof == null ? false : true,
    cardExpired   : state => state.cardExpired,
    filteredCardsByMerchant(state, getters, rootState, rootGetters ){
        let currentMerchant = rootGetters['merchant/currentMerchant'];
        //TODO: Move this logic to backend
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        let allDate = yyyy + "-" + mm + "-" + dd;
        let date = new Date(allDate).getTime();

        let bonusCards = state.wallet.filter ( card =>
            (card.Merchant.merchantId == currentMerchant.merchantId && card.PrepaidAccount.prepaidAccountTypeId == 3 && card.PrepaidAccount.balance > 0 && ((card.PrepaidAccount.futureActivationDate == null) || (date >= new Date(card.PrepaidAccount.futureActivationDate).getTime())) && ((card.PrepaidAccount.expirationDate == null) || (date < new Date(card.PrepaidAccount.expirationDate).getTime())) )
        )
     //console.log("Bonus cards here", bonusCards);
     //console.log(bonusCards);
     return bonusCards;
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
